import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import { useEffect, useState } from "react";
import config from "../config";

const useNotifications = (username: string) => {
  const [notifications, setNotifications] = useState<any[]>([]);

  useEffect(() => {
    console.log("Initializing WebSocket for user:", username);

    const socket = new SockJS(`${config.apiBaseUrl}/ws`);
    console.log("SockJS socket created:", socket);

    const stompClient = new Client({
      webSocketFactory: () => socket,
      debug: (str) => console.log("[STOMP DEBUG]:", str),
      reconnectDelay: 5000,
    });

    stompClient.onConnect = () => {
      console.log("STOMP client connected");

      const topic = `/topic/notifications/${username}`;
      console.log("Subscribing to topic:", topic);

      stompClient.subscribe(topic, (msg) => {
        console.log("Received STOMP message:", msg.body);

        const notification = JSON.parse(msg.body);
        setNotifications((prev) => [...prev, notification]);

        console.log("Updated notifications array:", [
          ...notifications,
          notification,
        ]);

        // Optional: show a toast or alert
        alert(notification.message);
      });
    };

    stompClient.onStompError = (frame) => {
      console.error("STOMP error:", frame.headers["message"], frame.body);
    };

    stompClient.onWebSocketError = (evt) => {
      console.error("WebSocket error:", evt);
    };

    stompClient.activate();
    console.log("STOMP client activated");

    return () => {
      console.log("Deactivating STOMP client");
      stompClient.deactivate();
    };
  }, [username]);

  return notifications;
};

export default useNotifications;
